;(function () {
  'use strict'

  angular
    .module('contrast.trace.events')
    .directive('csTraceEventRowSummary', csTraceEventRowSummary)

  function csTraceEventRowSummary() {
    return {
      restrict: 'A',
      templateUrl: 'components/trace-events/cs-trace-event-row-summary.html',
      require: '^csTraceEventRow'
    }
  }
})()
